import { render, staticRenderFns } from "./bi-datepicker.vue?vue&type=template&id=f041d304&"
import script from "./bi-datepicker.vue?vue&type=script&lang=ts&"
export * from "./bi-datepicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports